/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as _ from "lodash"

/**
 * Created by aditya on 06/02/18.
 */

export interface TimerProps {
    alarm?: number[];
    callBackOnAlarm?: (timeInMinutes: number) => void;
    callbackMessage?: string[];
    format?: "mm:ss" | "text";
    customCss?: any;
}

export interface TimerState {
    elapsedTime: number;
}

class Timer extends React.Component<TimerProps, TimerState> {
    private intervalFunction: any;
    constructor(props: TimerProps) {
        super(props);
        this.state = {
            elapsedTime: 0
        }
    }
    componentDidMount() {
        let myInstance = this;
        this.intervalFunction = setInterval(() => { myInstance.setState({ elapsedTime: myInstance.state.elapsedTime + 1 }) }, 1000);
        if (this.props.alarm !== undefined) {
            _.map(this.props.alarm, (time, index) => {
                let callbackMessage = !_.isEmpty(this.props.callbackMessage) ? this.props.callbackMessage : "Alarm";
                setTimeout(() => this.props.callBackOnAlarm(time), time * 60 * 1000)
            })
        }
    }
    componentWillUnmount() {
        clearInterval(this.intervalFunction);
    }
    formatTime(): string {
        let seconds = this.state.elapsedTime;
        let formattedMinutes: any = parseInt((seconds / 60).toString(), 10);
        let formattedSeconds: any = parseInt((seconds % 60).toString(), 10);
        formattedSeconds = formattedSeconds < 10 ? "0" + formattedSeconds : formattedSeconds;
        if (this.props.format === "text") {
            return `${formattedMinutes} min ${formattedSeconds} sec`
        }
        return `${formattedMinutes} : ${formattedSeconds}`
    }
    render() {
        let formattedTime = this.formatTime();
        return (
            <span css={this.props.customCss ?? {}}>{formattedTime}</span>
        )
    }
}

export default Timer;